(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const hash = window.location.hash;

    if (!hash) return;

    const viewMoreAnchor = document.getElementById('view-more-anchor');

    if (viewMoreAnchor && hash === '#view-more-anchor') {
      setTimeout(() => {
        viewMoreAnchor.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 500);
    } else {
      const fallbackEl = document.getElementById(hash.slice(1));
      if (fallbackEl) {
        fallbackEl.scrollIntoView({
          behavior: 'instant',
          block: 'start'
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
